module.exports = __webpack_public_path__ + "static/img/document-icon.ff43dc03.svg";